import Dashboard from "../Calculator_EpfRebalancer/EPF_partial_Dashboard";
import ClientDebtSummary from "../Calculator_EpfRebalancer/EPF_partial_ClientDebtSummary_Secured_Token_Test";
import Breadcrumbs from '../../../src/components/Breadcrumbs';

import React, { useEffect } from 'react';
import Swal from 'sweetalert2';

const EPFRebalancer_Secured_Token_Test = () => {
  useEffect(() => {
    Swal.fire({
        icon: "warning",
        title: "Reminder to all users",
        text: "This page is currently intended for testing only. For any concerns, please reach out to the development team.",
        confirmButtonColor: '#A5CC2D', 
      });
  }, []);
  
  return (
      <div className="app-container">
         <div className="container">
            <h1>EPF Rebalancer</h1>
            <Breadcrumbs />
            <Dashboard />
            <div className="app-column">
                <ClientDebtSummary />
            </div>
            <label className="custom-footer">© 2025 Pacific Debt Relief. All rights reserved. </label>
            <br/> <br/> <br/> <br/>
          </div> 
      </div>
  );
};

export default EPFRebalancer_Secured_Token_Test;